import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { PersonalisedTemplatePatchDTO } from 'crono-fe-common/types/DTO/personalisedTemplatePatchDTO';
import { useRoleCapabilities } from 'hooks/useRoleCapabilities';

export default function usePatchPersonalisedTemplate() {
  const queryClient = useQueryClient();
  const { isManager } = useRoleCapabilities();

  const patchPersonalisedTemplate = ({
    onBehalf,
    ...personalisedTemplatePatch
  }: PersonalisedTemplatePatchDTO) => {
    const request: Request = {
      url: `${ENDPOINTS.personalizedTemplate.main}`,
      config: {
        method: 'patch',
        data: {
          data: {
            ...personalisedTemplatePatch,
            //The flag is omitted rather than sent as false: non-managers sending it at all are rejected with 400
            ...(onBehalf && isManager && { onBehalf: true }),
          },
        },
      },
    };
    return client(request);
  };

  return useMutation<Response<null>, CronoError, PersonalisedTemplatePatchDTO>(
    patchPersonalisedTemplate,
    {
      onSettled: () => {
        queryClient.invalidateQueries([ENDPOINTS.task.search]);
        queryClient.invalidateQueries([ENDPOINTS.task.main]);
        queryClient.invalidateQueries([ENDPOINTS.task.overdue]);
        queryClient.invalidateQueries([ENDPOINTS.task.next]);
        queryClient.invalidateQueries([ENDPOINTS.task.aggregate]);
        queryClient.invalidateQueries([ENDPOINTS.task.total]);
        queryClient.invalidateQueries([ENDPOINTS.task.dailyQuantity]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.prospect]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
        queryClient.invalidateQueries([ENDPOINTS.prospect.search.strategy]);
        queryClient.invalidateQueries([ENDPOINTS.task.linkedin.quantity]);
      },
    },
  );
}
